import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { GlobalContext } from 'core/contexts/global-context'

import GalleryIcon from './icons/GalleryIcon'
import ListIcon from './icons/ListIcon'
import ArrowIcon from 'core/components/icons/ArrowIcon'

const Titlebar = props => {
  const global = useContext(GlobalContext)

  const icon = {
    gallery: { svg: <ListIcon />, title: 'LIST VIEW' },
    list: { svg: <GalleryIcon />, title: 'GALLERY VIEW' }
  }

  return (
    <header className="window-titlebar">
      <div className="window-title type-body mod-ui">{props.title}</div>

      {props.layout && (
        <button className="view-projects type-body mod-ui" onClick={props.toggleLayout}>
          {icon[props.layout].svg}
          {icon[props.layout].title}
        </button>
      )}

      {props.previous && (
        <Link to={props.previous} className="window-titlebar-icon window-titlebar-previous">
          <ArrowIcon />
        </Link>
      )}

      {props.next && (
        <Link to={props.next} className="window-titlebar-icon window-titlebar-next">
          <ArrowIcon />
        </Link>
      )}

      {props.close && (
        <button
          className="window-close"
          aria-label="close window"
          onClick={props.close}
          data-field={props.datafield}
        ></button>
      )}
    </header>
  )
}

Titlebar.defaultProps = {
  datafield: '',
  title: ''
}

Titlebar.propTypes = {
  previous: PropTypes.string,
  next: PropTypes.string,
  close: PropTypes.func,
  datafield: PropTypes.string,
  title: PropTypes.string,
  sort: PropTypes.bool,
  toggleLayout: PropTypes.func
}

export default Titlebar
